import React, { useCallback, useEffect, useState } from "react";
import Header from "../header";
import SearchField from "../../searchField";
import Button from "../../Button";
import { FiPlus } from "react-icons/fi";
import LoanTable from "../tables/Loan-Tables/loanTable";
import Modal from "../../modal";
import SelectInput from "../../selectInput";
import Input from "../../Input";
import DateInput from "../../dateInput";
import { getPayment } from "../../../redux/payment/action";
import { getVendors } from "../../../redux/vendors/action";
import { useDispatch, useSelector } from "react-redux";
import { getLoanType } from "../../../redux/Loan-type/action";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { AddLoan, GetLoan } from "../../../redux/Loan/action";
import { validateLoanData } from "../../../validation/validateLoan";

const Loan = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState({
    type: "",
    date: "",
    amount: "",
    vendorname: "",
    paymentmethod: "",
  });
  const [filter] = useState({
    page: 1,
    limit: 10,
    search: "",
  });
  const [loading, setLoading] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [errors, setErrors] = useState({});
  const [searchValue, setSearchValue] = useState("");

  // Other states
  const [paymentPage, setPaymentPage] = useState(20);
  const [vendorPage, setVendorPage] = useState(20);
  const [LoanTypePage, setLoanTypePage] = useState(20);

  const getPaymentData = useSelector(
    (state) => state?.Payment?.getPayment?.data
  );
  const getVendorsData = useSelector(
    (state) => state?.Vendors?.getVendors?.data
  );
  const getLoanTypeData = useSelector(
    (state) => state?.LoanType?.getLoanType?.data
  );

  const paymentOption = getPaymentData?.map((e) => {
    return {
      lable: e?.paymentmethod,
      value: e?._id,
    };
  });
  const vendorOption = getVendorsData?.map((e) => {
    return {
      lable: e?.name,
      value: e?._id,
    };
  });
  const loanTypeOption = getLoanTypeData?.map((e) => {
    return {
      lable: e?.loantype,
      value: e?._id,
    };
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    if (isSubmit) {
      const validationErrors = validateLoanData({
        ...data,
        [name]: value,
      });
      setErrors(validationErrors);
    }
  };

  const handleDateChange = (date, dateString) => {
    setData((prevData) => ({
      ...prevData,
      date: dateString,
    }));

    if (isSubmit) {
      const validationErrors = validateLoanData({
        ...data,
        date: dateString,
      });
      setErrors(validationErrors);
    }
  };

  const openModal = () => setIsOpen(true);
  const closeModal = () => {
    setIsOpen(false);
    resetForm();
  };

  const resetForm = () => {
    setData({
      type: "",
      date: "",
      amount: "",
      vendorname: "",
      paymentmethod: "",
    });
  };

  const handleSubmit = async () => {
    setIsSubmit(true);
    const validationErrors = validateLoanData(data);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      setLoading(true);
      try {
        let obj = {
          type: data?.type,
          date: data?.date,
          amount: Number(data?.amount),
          vendorname: data?.vendorname,
          paymentmethod: data?.paymentmethod,
        };
        await dispatch(AddLoan(obj)).then((res) => {
          if (res?.status === 200) {
            resetForm();
            closeModal();
            setLoading(false);
            dispatch(
              GetLoan({
                page: filter?.page,
                limit: filter?.limit,
                vendorname: searchValue,
              })
            );
          } else if (res?.status === 401) {
            setLoading(false);
            navigate("/");
          }
        });
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.log("error", error);
        return error;
      }
      setLoading(false);
    }
  };

  const fetchMoreOptions = useCallback(() => {
    dispatch(
      getPayment({ page: 1, limit: paymentPage, search: searchValue })
    ).then((res) => {
      if (res?.status === 200) {
        setPaymentPage((prev) => prev + 10);
      }
    });
  }, [dispatch, paymentPage, searchValue]);

  const fetchMoreOptionsVendor = useCallback(() => {
    dispatch(
      getVendors({ page: 1, limit: vendorPage, search: searchValue })
    ).then((res) => {
      if (res?.status === 200) {
        setVendorPage((prev) => prev + 10);
      }
    });
  }, [dispatch, vendorPage, searchValue]);

  const fetchMoreOptionsLoanType = useCallback(() => {
    dispatch(getLoanType({ page: 1, limit: LoanTypePage })).then((res) => {
      if (res?.status === 200) {
        setLoanTypePage((prev) => prev + 10);
      }
    });
  }, [dispatch, LoanTypePage]);

  useEffect(() => {
    dispatch(
      getPayment({
        page: filter?.page,
        limit: filter?.limit,
        search: filter?.search,
      })
    );
    dispatch(
      getVendors({
        page: filter?.page,
        limit: filter?.limit,
        search: filter?.search,
      })
    );
    dispatch(getLoanType({ page: 1, limit: 10 }));
  }, [dispatch, filter?.limit, filter?.page, filter?.search]);


  return (
    <div className="w-full px-8 py-2 flex flex-col gap-[30px]">
      <Header title={"Loan"} />

      <div className="flex items-center justify-end gap-5">
        <SearchField
          searchValue={searchValue}
          setSearchValue={setSearchValue}
        />
        <Button
          onClick={openModal}
          className={"bg-green hover:bg-darkgreen text-white"}
          icon={<FiPlus />}
          children={"Add New Loan"}
        />
      </div>

      <Modal
        loading={loading}
        modalWidth={"w-1/2"}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        openModal={openModal}
        closeModal={closeModal}
        imgSrc="/images/addLoan.svg"
        title="Add New Loan"
        btn1="Cancel"
        btn2="Add Loan"
        type2={"submit"}
        btnClass={"justify-end"}
        modalContent={
          <div className="grid grid-cols-2 gap-x-5 gap-y-5 text-base font-normal">
            <div>
              <SelectInput
                lableName={"Type"}
                option={loanTypeOption}
                onChange={handleChange}
                value={data?.type}
                name={"type"}
                fetchMoreOptions={fetchMoreOptionsLoanType}
              />
              {errors.type && (
                <div className="text-red-500 text-sm">{errors.type}</div>
              )}
            </div>

            <div>
              <DateInput
                onChange={handleDateChange}
                value={data.date ? dayjs(data.date, "DD/MM/YYYY") : null}
                name={"date"}
              />
              {errors.date && (
                <div className="text-red-500 text-sm">{errors.date}</div>
              )}
            </div>

            <div>
              <Input
                lableName={"Amount"}
                inputType={"number"}
                currency={true}
                onChange={handleChange}
                value={data?.amount}
                name={"amount"}
              />
              {errors.amount && (
                <div className="text-red-500 text-sm">{errors.amount}</div>
              )}
            </div>

            <div>
              <SelectInput
                lableName={"Vendor Name"}
                option={vendorOption}
                onChange={handleChange}
                value={data?.vendorname}
                name={"vendorname"}
                fetchMoreOptions={fetchMoreOptionsVendor}
              />
              {errors.vendorname && (
                <div className="text-red-500 text-sm">{errors.vendorname}</div>
              )}
            </div>

            <div>
              <SelectInput
                lableName={"Payment Method"}
                option={paymentOption}
                onChange={handleChange}
                value={data?.paymentmethod}
                name={"paymentmethod"}
                fetchMoreOptions={fetchMoreOptions}
              />
              {errors.paymentmethod && (
                <div className="text-red-500 text-sm">
                  {errors.paymentmethod}
                </div>
              )}
            </div>
          </div>
        }
        handleBtn2={handleSubmit}
      />

      <LoanTable searchValue={searchValue} />
    </div>
  );
};

export default Loan;
